import { render, staticRenderFns } from "./SnTabsV3.vue?vue&type=template&id=6c0430b3&scoped=true"
import script from "./SnTabsV3.vue?vue&type=script&lang=js"
export * from "./SnTabsV3.vue?vue&type=script&lang=js"
import style0 from "./SnTabsV3.vue?vue&type=style&index=0&id=6c0430b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0430b3",
  null
  
)

export default component.exports